<template>
  <div>
    <van-cell-group>
      <van-field
          v-model="content"
          :label="label"
          :placeholder="placeholder"
          :error = "err"
          :type="type"
          :error-message = "errMsg"
          @click = "handelInput">
        <template #button v-if="showButton">
          <div @click="handeClick" style="color:#000;">
            {{ buttonMsg }}
          </div>
        </template>
      </van-field>
    </van-cell-group>
  </div>
</template>

<script>
export default {
  data() {
    return {
      content:"",
      err : false,
      errMsg:"",
    }
  },
  name: "FieldText",
  props:["label", "placeholder", "type", "showButton", "buttonMsg"],
  watch:{
    content() {
      this.$emit("contentWatch", this.content)
    }
  },
  methods:{
    handelInput(){
      this.content="";
      this.err = false
      this.errMsg = ""
    },
    handeClick(e){
      this.$emit("handeClick", e)
    }
  }
}
</script>

<style scoped>

</style>
